// extracted by mini-css-extract-plugin
export var boldText = "_75-4";
export var checkboxContainer = "_75-6";
export var closeIcon = "_75-i";
export var container = "_75-0";
export var drawer = "_75-8";
export var drawerContent = "_75-9";
export var extraSmallText = "_75-5";
export var fulfillmentGroupTable = "_75-e";
export var largeText = "_75-3";
export var loadingSpinnerContainer = "_75-j";
export var mediumText = "_75-2";
export var narrow = "_75-f";
export var notificationLink = "_75-l";
export var packageCheckIconContainer = "_75-7";
export var slideoutHeaderActions = "_75-g";
export var slideoutHeaderActionsShifted = "_75-h";
export var slideoutHeaderContainer = "_75-a";
export var slideoutModal = "_75-c";
export var stickyHeaderWrapper = "_75-b";
export var table = "_75-k";
export var tableContainer = "_75-d";
export var tertiaryText = "_75-1";